import { useNavigate } from 'react-router';
import { Outcome, PublishedEventListItem, TopMarketTypeDisplay } from '../@types';
import { addOrRemoveBetslipBet } from '../stores/betslip/selectors';
import { createBetslipSelection } from '../utils/betslipSelection';

export const useEventCard = (event: PublishedEventListItem, topMarketTypes?: TopMarketTypeDisplay[]) => {
  const { startDate, participants, topMarkets } = event;
  const topMarket = topMarkets?.[0];
  const outcomeTypes = topMarketTypes?.[0]?.outcomeTypes ?? topMarket?.marketType?.outcomeTypes;

  const navigate = useNavigate();

  const addToBetslip = (outcome: Outcome) => {
    if (!topMarket) return;

    addOrRemoveBetslipBet(createBetslipSelection({ event, market: topMarket, outcome }));
  };

  const handleContentClick = () => {
    navigate(`/sports/events/${event.id}`);
  };

  const getOutcomeForType = (outcomeTypeId: string) =>
    topMarket?.outcomes?.find((item) => item.outcomeTypeId === outcomeTypeId);

  return {
    startDate,
    participants,
    topMarket,
    outcomeTypes,
    addToBetslip,
    handleContentClick,
    getOutcomeForType,
  };
};
